import get from 'lodash.get';
import { fetchQuery } from 'react-relay';
import {
    hasUserSessionGeoInfoByIpAddress,
    setUserSessionGeoInfoByIpAddress,
} from '../../src/utils/regionalInfoHelpers';
import { userGeoInfoQuery } from '../queries/userGeoInfoQuery';

const setUserRegionInfo = ({ relayEnv, cookieDomain, hasRegionsCookieValue }) => {
    if (!hasUserSessionGeoInfoByIpAddress() || !hasRegionsCookieValue) {
        fetchQuery(relayEnv, userGeoInfoQuery, {
            cookieDomain: !hasRegionsCookieValue ? cookieDomain : '',
        }).then(data => {
            const userGeoInfo = get(data, 'viewer.regionalInfo[0]');
            setUserSessionGeoInfoByIpAddress(userGeoInfo);
        });
    }
};

export { setUserRegionInfo };
